/** @jsx $mol_jsx */
/** @jsxFrag $mol_jsx_frag */
namespace $.$$ {
	$mol_jsx_view
	export class $shm_hitalama_map_widget_float_autoview extends $.$shm_hitalama_map_widget_float_autoview {
		fullsize_height() {
			return this.auto_height() && !this.fullscreen_attr() ? '' : '100%'
		}

		code_widget(): $shm_hitalama_map_widget {
			return this.widget().code_widget() ?? this.widget()
		}

		icon() {
			return $mol_error_fence( ()=> {
				const result = this.result()
				if( result?._format === 'table' ) return $mol_icon_table
				if( result instanceof $mol_button_minor ) return $mol_icon_gesture_tap_button
				if( result instanceof $mol_string ) return $mol_icon_form_textbox
				if( result instanceof $mol_textarea ) return $mol_icon_form_textarea
				if( result instanceof $mol_select ) return $mol_icon_form_dropdown
				if( result instanceof $mol_check_box ) return $mol_icon_checkbox_marked_outline
				if( result instanceof $mol_list ) return $mol_icon_format_list_bulleted
				if( result instanceof $mol_view ) return $mol_icon_cube_scan
				if( typeof Node !== 'undefined' && result instanceof Node ) return $mol_icon_language_html5
			}, ()=> {
				return $mol_icon_cube_scan
			} )
		}
		
		skip_drag( el: Element ) {
			if( el.shadowRoot ) return true
			return super.skip_drag(el)
		}

		@ $mol_mem
		autoview_plain() {
			const res = this.result()
			if( res === undefined ) return false
			if( res?._format == 'table' ) return false
			if( res instanceof $mol_view ) return false
			if( res?.getAttribute?.('data-crus-ref') ) return false
			if( res instanceof Node ) return false
			return true
		}

		@ $mol_mem
		autoview_plain_tools() {
			return this.autoview_plain() ? super.autoview_plain_tools() : []
		}

	}
}
